var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5783 8.4891C38.2058 4.1166 32.2754 1.66016 26.0918 1.66016C19.9081 1.66016 13.9777 4.1166 9.60525 8.4891C5.23275 12.8616 2.77631 18.792 2.77631 24.9756C2.77631 31.1593 5.23275 37.0896 9.60525 41.4621C13.9777 45.8346 19.9081 48.2911 26.0918 48.2911C32.2754 48.2911 38.2058 45.8346 42.5783 41.4621C46.9508 37.0896 49.4072 31.1593 49.4072 24.9756C49.4072 18.792 46.9508 12.8616 42.5783 8.4891ZM26.0918 45.1661C14.959 45.1661 5.90134 36.1086 5.90134 24.9756C5.90134 13.8426 14.9588 4.78519 26.0918 4.78519C37.2248 4.78519 46.2822 13.8426 46.2822 24.9756C46.2822 36.1086 37.2248 45.1661 26.0918 45.1661Z",
    fill: "#716358"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5781 29.8641L15.4089 22.695L13.1992 24.9046L22.5781 34.2835L38.9355 17.9262L36.7258 15.7166L22.5781 29.8641Z",
    fill: "#716358"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.75a967bb6e8b86c2a4e5187ba5d8b01a.svg";
export { ForwardRef as ReactComponent };